/* @flow */

import type { RoleList } from './defs';
import { Roles } from './defs';

export const read: RoleList = [Roles.SYSTEM_ADMIN, Roles.SYSTEM_ADMIN_REGIONAL];
export const create: RoleList = [Roles.SYSTEM_ADMIN, Roles.SYSTEM_ADMIN_REGIONAL];
export const update: RoleList = [Roles.SYSTEM_ADMIN, Roles.SYSTEM_ADMIN_REGIONAL];
export const remove: RoleList = [Roles.SYSTEM_ADMIN, Roles.SYSTEM_ADMIN_REGIONAL];
